import { useState, useEffect } from "react"
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from "axios";
import { EventList } from './EventList';
import { EventListSwiper } from './EventListSwiper';
import { MonthFilter } from './MonthFilter';

function DisplayEvents() {
  const [eventList, setEventList] = useState([]);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [isLoading, setIsLoading] = useState(true);

  const fetchEvents = async () => {
    try {
      const allEvents = [];
      let page = 1;
      let totalPages = 1;

      do {
        const res = await axios.get(
          `/wp-json/wp/v2/events?_embed&meta_key=event_date&order=asc&per_page=100&page=${page}`
        );
        allEvents.push(...res.data);
        totalPages = parseInt(res.headers['x-wp-totalpages'] ?? '1', 10);
        page++;
      } while (page <= totalPages);

      setEventList(allEvents);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setIsLoading(false);
    }
  };
  //
  useEffect(() => {
    fetchEvents();
  }, []);
  //
  return (
    <Router>
      {isLoading ? (
        <div className="text-center my-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/rum-bar/" element={<EventListSwiper eventList={eventList} currentMonthIndex={currentMonthIndex} currentYear={currentYear} />} />
          <Route path="/events/" element={
            <>
              <MonthFilter
                eventList={eventList}
                currentMonthIndex={currentMonthIndex}
                setCurrentMonthIndex={setCurrentMonthIndex}
                currentYear={currentYear}
                setCurrentYear={setCurrentYear}
              />
              <EventList
                eventList={eventList}
                currentMonthIndex={currentMonthIndex}
                currentYear={currentYear}
              />
            </>
          }
          />
        </Routes>
      )}
    </Router>
  );
}

export default DisplayEvents;